// Türkçe ve adres normalizasyonu + baseType (başka yerler kullanıyorsa)
export const trMap = {
  ç: "c", ğ: "g", ı: "i", i: "i", ö: "o", ş: "s", ü: "u",
  Ç: "c", Ğ: "g", I: "i", İ: "i", Ö: "o", Ş: "s", Ü: "u",
};

export function trNormalize(s) {
  if (s == null) return "";
  return String(s)
    .replace(/[çğıöşüÇĞIİÖŞÜ]/g, (c) => trMap[c] || c)
    .toLowerCase()
    .trim();
}

// Adres eşleştirme için normalize anahtar
export function addrKey(s) {
  const t = trNormalize(s)
    .replace(/\b(caddesi|cad\.?|cd\.?)\b/g, "cadde")
    .replace(/\b(sokağı|sokagi|sokak|sk\.?)\b/g, "sokak")
    .replace(/\b(bulvarı|bulvari|blv\.?)\b/g, "bulvar")
    .replace(/\b(mahallesi|mah\.?)\b/g, "mahalle")
    .replace(/\b(önü|yönü|karşısı|öncesi|sonrası|karşı|ön|arka|üst|alt)\b/g, "")
    .replace(/[^a-z0-9]+/g, " ")
    .replace(/\s+/g, " ")
    .trim();
  return t;
}

// Eski kodların ihtiyacı varsa:
export function baseType(s) {
  const t = trNormalize(s);
  if (!t) return "";
  const parts = t.split(/[^a-z0-9]+/).filter(Boolean);
  return parts[parts.length - 1] || t;
}
